export default "__VITE_ASSET__CnYV8kns__"